<template>
  <div>
      <v-layout wrap row justify-start pa-2 py-5>
        <v-flex xs6 px-2>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Influncers Paymet By Key or Document Number
						</v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md12 pa-1>
									<v-textarea
										label="Keys OR Document Numbers"
										v-model="spastedData"
										solo
									></v-textarea>
              	</v-flex>
                <v-flex xs12 class="text-xs-center" pb-5>
                  <v-btn color="primary" @click="searchByKey()">fetch leads by key</v-btn>
                  <v-btn color="primary" @click="searchByDoc()">fetch leads by document</v-btn>
                </v-flex>
                <v-flex xs12 class="text-xs-center" style="font-weight:bold;">
                  {{leads.length}} / {{totalW}}
                </v-flex>
                <v-flex xs12 class="text-xs-center" style="font-weight:bold;">
                  Leads
                </v-flex>
                
                <v-flex xs12 class="text-xs-center" style="font-weight:bold;">
                  Leads
                </v-flex>
                <v-flex xs12 py-3 px-1 style="background:#efefef;max-height:600px;overflow-y:scroll;">
                  <v-flex xs12 class="text-xs-center">
                    <v-btn color="primary" @click="exporLeadsByKey()">export leads</v-btn>
                  </v-flex>
                  <v-layout row wrap v-if="leads && leads.length">
                    <v-flex xs12 py-1 v-for="(lead, l) in leads" :key="l+'-lead'">
                      <v-card>
                        <v-layout row wrap pa-2>
                          <v-flex v-if="lead.phone_number_1" xs6 md2>
                            <div class="caption grey--text ">Phone</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.phone_number_1"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >{{ lead.phone_number_1 }}
                              </span>
                              <span>{{ lead.phone_number_1 }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.order_status" xs6 md2>
                            <div class="caption grey--text ">Order Status</div>
                            <v-tooltip top>
                              <span slot="activator">{{ lead.order_status }}</span>
                              <span>{{ lead.order_status }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.key" xs6 md1>
                            <div class="caption grey--text ">Key</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.key"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >
                                copy
                              </span>
                              <span>{{ lead.key }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.document_number" xs6 md1>
                            <div class="caption grey--text ">Doc</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.document_number"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >
                                copy
                              </span>
                              <span>{{ lead.document_number }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.shipping_status" xs6 md2>
                            <div class="caption grey--text ">Shipping Status</div>
                            <v-tooltip top>
                              <span slot="activator">{{ lead.shipping_status | truncate(15, (lead.shipping_status.length>15 ? '..': '')) }}</span>
                              <span>{{ lead.shipping_status }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.order" xs6 md2>
                            <div class="caption grey--text ">Items</div>
                            <v-layout row wrap>
                              <v-flex xs12 v-for="(tt, jj) in lead.order" :key="jj+'-iteminorder'">
                                <v-tooltip top>
                                  <span slot="activator"
                                    v-clipboard:copy="tt.sku"
                                    v-clipboard:success="clipboardSuccessHandler"
                                    v-clipboard:error="clipboardErrorHandler"
                                  >
                                    {{tt.sku}}
                                  </span>
                                  <span>{{ tt.sku }}</span>
                                </v-tooltip>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex v-if="lead.done" xs6 md1>
                            <div class="caption grey--text ">Done</div>
                            <v-tooltip top>
                              <span slot="activator">
                                <v-avatar
                                  size="15"
                                  color="success"
                                >
                                  <v-icon>done_all</v-icon>
                                </v-avatar>
                              </span>
                              <span>done</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="text-xs-center" style="font-weight:bold;">
                  Not found keys
                </v-flex>
                <v-flex xs12 py-3 px-1 style="background:#efefef;max-height:600px;overflow-y:scroll;">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-btn color="success" small @click="exportData(nKeys)">export</v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap v-if="nKeys && nKeys.length">
                    <v-flex xs12 py-1 v-for="(key, kk) in nKeys" :key="kk+'-kkeyy'">
                      <v-card>
                        <v-layout row wrap pa-2>
                          <v-flex v-if="key" xs6 md6>
                            <div class="caption grey--text ">Key / Document Number</div>
                            <v-tooltip top>
                              <span slot="activator">{{ key }}</span>
                              <span>{{ key }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex xs12 xs6 md6>
                            <v-btn 
                              v-clipboard:copy="key"
                              v-clipboard:success="clipboardSuccessHandler"
                              v-clipboard:error="clipboardErrorHandler"
                              flat small color="primary">copy</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="text-xs-center" style="font-weight:bold;">
                  Updated Leads {{ dleads.length }} / {{ totalW - nKeys.length }}
                </v-flex>
                <v-flex xs12 py-3 px-1 style="background:#efefef;max-height:600px;overflow-y:scroll;">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-btn color="success" small @click="exportData(dleads)">export</v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap v-if="dleads && dleads.length">
                    <v-flex xs12 py-1 v-for="(lead, l) in dleads" :key="l+'-dlead'">
                      <v-card>
                        <v-layout row wrap pa-2>
                          <v-flex v-if="lead.phone_number_1" xs6 md2>
                            <div class="caption grey--text ">Phone</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.phone_number_1"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >{{ lead.phone_number_1 }}
                              </span>
                              <span>{{ lead.phone_number_1 }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.order_status" xs6 md2>
                            <div class="caption grey--text ">Order Status</div>
                            <v-tooltip top>
                              <span slot="activator">{{ lead.order_status }}</span>
                              <span>{{ lead.order_status }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.key" xs6 md1>
                            <div class="caption grey--text ">Key</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.key"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >
                                copy
                              </span>
                              <span>{{ lead.key }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.document_number" xs6 md1>
                            <div class="caption grey--text ">Doc</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.document_number"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >
                                copy
                              </span>
                              <span>{{ lead.document_number }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.shipping_status" xs6 md2>
                            <div class="caption grey--text ">Shipping Status</div>
                            <v-tooltip top>
                              <span slot="activator">{{ lead.shipping_status | truncate(15, (lead.shipping_status.length>15 ? '..': '')) }}</span>
                              <span>{{ lead.shipping_status }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.order" xs6 md2>
                            <div class="caption grey--text ">Items</div>
                            <v-layout row wrap>
                              <v-flex xs12 v-for="(tt, jj) in lead.order" :key="jj+'-iteminorder'">
                                <v-tooltip top>
                                  <span slot="activator"
                                    v-clipboard:copy="tt.sku"
                                    v-clipboard:success="clipboardSuccessHandler"
                                    v-clipboard:error="clipboardErrorHandler"
                                  >
                                    {{tt.sku}}
                                  </span>
                                  <span>{{ tt.sku }}</span>
                                </v-tooltip>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex v-if="lead.done" xs6 md1>
                            <div class="caption grey--text ">Done</div>
                            <v-tooltip top>
                              <span slot="activator">
                                <v-avatar
                                  size="15"
                                  color="success"
                                >
                                  <v-icon>done_all</v-icon>
                                </v-avatar>
                              </span>
                              <span>done</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="text-xs-center" style="font-weight:bold;">
                  Failed Payment Transactions {{ ftleads.length }}
                </v-flex>
                <v-flex xs12 py-3 px-1 style="background:#efefef;max-height:600px;overflow-y:scroll;">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-btn color="success" small @click="exportData(ftleads)">export</v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap v-if="ftleads && ftleads.length">
                    <v-flex xs12 py-1 v-for="(lead, l) in ftleads" :key="l+'-ftlead'">
                      <v-card>
                        <v-layout row wrap pa-2>
                          <v-flex v-if="lead.phone_number_1" xs6 md2>
                            <div class="caption grey--text ">Phone</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.phone_number_1"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >{{ lead.phone_number_1 }}
                              </span>
                              <span>{{ lead.phone_number_1 }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.order_status" xs6 md2>
                            <div class="caption grey--text ">Order Status</div>
                            <v-tooltip top>
                              <span slot="activator">{{ lead.order_status }}</span>
                              <span>{{ lead.order_status }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.key" xs6 md1>
                            <div class="caption grey--text ">Key</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.key"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >
                                copy
                              </span>
                              <span>{{ lead.key }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.document_number" xs6 md1>
                            <div class="caption grey--text ">Doc</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.document_number"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >
                                copy
                              </span>
                              <span>{{ lead.document_number }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.shipping_status" xs6 md2>
                            <div class="caption grey--text ">Shipping Status</div>
                            <v-tooltip top>
                              <span slot="activator">{{ lead.shipping_status | truncate(15, (lead.shipping_status.length>15 ? '..': '')) }}</span>
                              <span>{{ lead.shipping_status }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.order" xs6 md2>
                            <div class="caption grey--text ">Items</div>
                            <v-layout row wrap>
                              <v-flex xs12 v-for="(tt, jj) in lead.order" :key="jj+'-iteminorder'">
                                <v-tooltip top>
                                  <span slot="activator"
                                    v-clipboard:copy="tt.sku"
                                    v-clipboard:success="clipboardSuccessHandler"
                                    v-clipboard:error="clipboardErrorHandler"
                                  >
                                    {{tt.sku}}
                                  </span>
                                  <span>{{ tt.sku }}</span>
                                </v-tooltip>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex v-if="lead.done" xs6 md1>
                            <div class="caption grey--text ">Done</div>
                            <v-tooltip top>
                              <span slot="activator">
                                <v-avatar
                                  size="15"
                                  color="success"
                                >
                                  <v-icon>done_all</v-icon>
                                </v-avatar>
                              </span>
                              <span>done</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <!-- <v-flex xs12 class="text-xs-center" style="font-weight:bold;" v-if="false">
                  Failed SKU Transactions on Orders {{ fttleads.length }}
                </v-flex>
                <v-flex xs12 py-3 px-1 style="background:#efefef;max-height:600px;overflow-y:scroll;">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-btn color="success" small @click="exportData(fttleads)">export</v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap v-if="fttleads && fttleads.length">
                    <v-flex xs12 py-1 v-for="(lead, l) in fttleads" :key="l+'-ftlead'">
                      <v-card>
                        <v-layout row wrap pa-2>
                          <v-flex v-if="lead.order" xs6 md1>
                            <div class="caption grey--text ">Key</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.order"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >
                                copy
                              </span>
                              <span>{{ lead.order }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.sku" xs6 md2>
                            <div class="caption grey--text ">Shipping Status</div>
                            <v-tooltip top>
                              <span slot="activator">{{ lead.sku | truncate(15, (lead.sku.length>15 ? '..': '')) }}</span>
                              <span>{{ lead.sku }}</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex> -->
                <v-flex xs12 py-3>
                  <v-layout row wrap>
                    <v-flex xs6 pa-1>
                      <v-menu
                        v-model="fsd"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template slot="activator">
                          <v-text-field
                            v-model="fTLDate"
                            label="From Status Date"
                            append-icon="event"
                            readonly
                            :disabled="loading"
                            hide-details
                            clearable
                            solo
                            :loading="loading"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="fTLDate" @input="fsd = false"></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs6 pa-1>
                      <v-text-field
                        v-model="userName"
                        disabled
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 pa-1>
                      <v-switch label="Payment to influencer done" v-model="paid_to_influencer"></v-switch>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
							<v-btn @click="updatePaymentStatus()" :disabled="loading" :loading="loading" color="success" dark>
                update new data keys with payment status
              </v-btn>
            </v-card-actions>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-select
                :items="['key', 'document_number']"
                v-model="searchBy"
                label="Fetch By"
                :loading="loading"
                :disabled="loading"
              ></v-select>
              <v-btn @click="backUpdate()" :loading="loading" :disabled="loading" color="success" >
                update on backend
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate, sleep} from '@/customFunction';
import axios from 'axios';
import json2csv from 'json2csv'
let apiBase = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
const headers = {'Accept': 'application/json'};

export default {
  data(){
    return {
			loading: false,
      pastedData:null,
      spastedData:null,
      delimiter:',',
      fttleads:[],
      pKeys:[],
      leads:[],
      dleads:[],
      ftleads:[],
      nKeys:[],
      eleads:[],
      totalW:0,
      totalK:0,
      dArray:[],
      oArray:[],
      nArray:[],
      mArray:[],
      eArray:[],
      newShippingStatus:null,
      shippingStatus:[],
      fsd:null,
      fTLDate:null,
      warehouses:[],
      selectedWarehouse:null,
      products:[],
      searchBy:null,
      paid_to_influencer:false,
    }
  },
  methods: {
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
		guessDelimiters (text, possibleDelimiters) {
			return possibleDelimiters.filter(weedOut);
			function weedOut (delimiter) {
				var cache = -1;
				return text.split('\n').every(checkLength);
				function checkLength (line) {
					if (!line) {
							return true;
					}
					var length = line.split(delimiter).length;
					if (cache < 0) {
							cache = length;
					}
					return cache === length && length > 1;
				}
			}
		},
		getArray(){
			let csv = this.pastedData
			let dels = [' ', '  ', ',', '	', '\t']
			this.delimiter = ','
			if(this.delimiter && this.delimiter > 1) {
				this.$emit('snackbarNotification', `Please export as CSV`, 'error')
				return
			}
			var lines=csv.split("\n");
      var result = [];
			var headers=lines[0].split(this.delimiter);
			for(var i=1;i<lines.length;i++){
					if (!lines[i])
							continue
					var obj = {};
					var currentline=lines[i].split(this.delimiter);
					for(var j=0;j<headers.length;j++){
							obj[headers[j]] = currentline[j];
					}
					result.push(obj);
			}
			console.log(result);
			return result
    },
    async searchByKey(){
      this.leads = []
			let a = this.spastedData.split('\n').filter(x=> x && x.trim() != '').map(x=>{
        return {
          key: x.trim()
        } 
      });
      this.totalW = a.length;
      (async x=>{
        for (let i = 0; i < a.length; i++) {
          const r = a[i];
          if(!this.leads.map(x=>x.key).includes(r.key)) {
            let l = await store.collection('leads').doc(r.key).get().then(x=>x.data())
            if(l){
              if(!l.key) l.key = r.key
              this.leads.push(l)
              this.eleads.push(l)
            } else {
              this.nKeys.push(r.key)
            }
          }
        }
        console.log(this.leads)
      })()
    },
    async searchByDoc(){
      this.leads = []
			let a = this.spastedData.split('\n').filter(x=> x && x.trim() != '').map(x=>{
        return {
          document_number: x.trim()
        } 
      });
      this.totalW = a.length;
      (async x=>{
        for (let i = 0; i < a.length; i++) {
          const r = a[i];
          if(!this.leads.map(x=>x.document_number).includes(r.document_number)){
              let l = await store.collection('leads').where('document_number', '==', r.document_number).get().then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}}))
            if(l && l[0]) {
              this.leads.push(l[0])
              this.eleads.push(l[0])
            } else {
              this.nKeys.push(r.document_number)
            }
          }
        }
        console.log(this.leads)
      })()
    },
    allowPaymentChange(lead){
      return lead && lead.shipping_status && lead.shipping_status == 'Paid' && !lead.paid_to_influencer
    },
    async updatePaymentStatus() {
      if(!this.fTLDate){
        this.$emit('snackbarNotification', `Input missing`, 'error')
        return false
      }
      this.pKeys=[]
      this.fKeys=[]
      this.nKeys=[]
      let dateSetting = await db.ref(`settings/lockdate`).once('value').then(x=>x.val());
      let a = this.leads;
      (async () => {
				for (let i = 0; i < this.leads.length; i++) {
          const lead = this.leads[i];
          let transaction_id = randomString(8, '#Aa')
          let transaction_timestamp = new Date().getTime()
          if(this.allowPaymentChange(lead)) {
            console.log(lead.key)
            lead.paid_to_influencer = this.paid_to_influencer
            lead.paid_to_influencer_date = this.fTLDate
					  // await store.collection('leads').doc(lead.key).update(lead)

            this.dleads.push(lead)
            console.log('transaction', {
              user:this.$props.userName,
              date:getCDate(),
              status:status,
              transaction_timestamp,
              transaction_id,
              status_date:this.fTLDate,
              timestamp:new Date(getCDate()).getTime(),
              transaction:this.paid_to_influencer,
              company_code:this.leads[i].company_code,
              order_key:this.leads[i].key,
              document_number: this.leads[i].document_number ? this.leads[i].document_number : 0
            })
            // await store.collection('paymentactions').add({
            //   user:this.$props.userName,
            //   date:getCDate(),
            //   transaction_timestamp,
            //   transaction_id,
            //   status_date:this.fTLDate,
            //   timestamp:new Date(getCDate()).getTime(),
            //   transaction:this.paid_to_influencer,
            //   company_code:this.leads[i].company_code,
            //   order_key:this.leads[i].key,
            //   document_number: this.leads[i].document_number ? this.leads[i].document_number : 0
            // })
          } else {
            this.ftleads.push(lead)
          }
        }
      })()
    },
    exportData(data, name){
      if(data.length) {
        let a = json2csv.parse(data)
        console.log(a)
        let csvContent = "data:text/csv;charset=utf-8," 
        var encodedUri =  csvContent + encodeURIComponent(a);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        let n = name ? name : 'leads_export'
        link.setAttribute("download", `${n}.csv`);
        document.body.appendChild(link); // Required for FF
        link.click();
      }
    },
    exporLeadsByKey(){
      let leads = [...this.eleads]
      console.log('------------------------------------');
      console.log(leads);
      console.log('------------------------------------');
      let exportArray = []
      for (const key in leads) {
        if (leads.hasOwnProperty(key)) {
          const lead = leads[key];
          console.log('------------------------------------', lead);

          let k = lead.status_timeline ? Object.keys(lead.status_timeline) : null
          let lastcdate = lead.status_timeline ? Object.values(lead.status_timeline).map((x, i)=>{return {...x, key:k[i]}})
          .filter(x => x.key == 'dispatch')
          .sort((a, b) => {
            new Date(b.date).getTime() - new Date(a.date).getTime()
          })[0] : null
          let Sdates = {}
          let kShip = lead.shipping_status_timeline ? Object.keys(lead.shipping_status_timeline) : null
          let lastSdate = lead.shipping_status_timeline ? Object.values(lead.shipping_status_timeline)
          .forEach((x, i)=>{ Sdates[kShip[i]] = x.date }) : []

          if (lead.order) {
            let order = lead.order
            for (let i = 0; i < order.length; i++) {
              const item = order[i];
              //delete lead.order
              exportArray.push({
                ...lead,
                item_name: item.product,
                item_sku: item.sku,
                item_unite_price: item.baseprice,
                item_quantity: item.quantity,
                last_dispatch_date: lastcdate ? lastcdate.date : null,
                last_dispatch_agent: lastcdate ? lastcdate.agent : null,
                ...Sdates
              })
            }
          }
        }
      }
      console.log('------------------------------------');
      console.log(exportArray);
      console.log('------------------------------------');
      //let a = this.toCsv(this.pivot(exportArray))
      let a = json2csv.parse(exportArray)
      console.log(a)
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri =  csvContent + encodeURIComponent(a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `leads_export.csv`);
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    async backUpdate(){
      this.loading = true
      if(!this.fTLDate || !this.searchBy){
        this.$emit('snackbarNotification', `Input missing`, 'error')
        this.loading = false
        return false
      }
      let a = this.spastedData.split('\n').filter(x=> x && x.trim() != '').map(x=>x.trim());
      let exportLeads = [];
      let beforeLeads = [];
      let limit = 200
      let numNeeded = a.length / limit
      let loops = a.length % limit == 0 ? a.length / limit : parseInt(a.length / limit) + 1;
      
      (async x=>{
        for (let i = 0; i < loops + 1; i++) {
          await sleep(15000)
          let data = {
            keys:a.slice(i*limit, i*limit+limit),
            paid_to_influencer:this.paid_to_influencer,
            userName:this.$props.userName,
            fTLDate:this.fTLDate,
            searchBy:this.searchBy
          }
          console.log(data)
          let m = await axios.post(`${apiBase}/paymentUpdate`, data, headers).then(x=>x.data)
          console.log(m)
          this.nKeys = [...this.nKeys, ...m.notfound]
          this.dleads = [...this.dleads, ...m.leads_with_changed_status]
          this.ftleads = [...this.ftleads, ...m.leads_with_failed_transaction]
          exportLeads = [...exportLeads, ...m.leads]
          beforeLeads = [...beforeLeads, ...m.before_edit_leads]
        }
        this.exportData(beforeLeads, 'Before_edit_leads')
        this.exportData(exportLeads, 'Ready_leads_export')
        this.loading = false
      })()
    }
  },
  props:{
		superAdmin:{
			required:true
		},
		userName:{
			default:null
		},
		beta:{
			default:null
		}
  },
  computed:{
    
  },
  async created(){
    
  }
}
</script>

<style>
.tokenField * {
  color:white !important;
}
</style>
